<div class="offline-banner" *ngIf="isOffline$ | async">
  {{ 'YouAreCurrentlyOffline' | translate }}
</div>

<div class="network-timeout-banner" *ngIf="showTimeoutBanner$ | async">
  <div>
    <span>{{ 'ConnectionIsUnstable' | translate }}</span>
  </div>
  <div>
    <button (click)="retryRequest()">{{ 'Retry' | translate }}</button>
  </div>
</div>

<!-- <div class="generic-error-modal-overlay" *ngIf="showGenericError$ | async">
  <div class="generic-error-modal">
    <p>{{ 'SomethingWentWrong' | translate }}</p>
    <div class="actions">
      <button (click)="refreshPage()">{{ 'Refresh' | translate }}</button>
      <button (click)="closeGenericError()">{{ 'Cancel' | translate }}</button>
    </div>
  </div>
</div> -->

<!-- <app-topbar></app-topbar> -->
<lib-toastify-toast-container
  [transition]="'flip'"
  [hideProgressBar]="true"
  [newestOnTop]="true"
  [iconLibrary]="'material'"
></lib-toastify-toast-container>
<div class="notranslate">
  <router-outlet></router-outlet>
</div>
